import React, { useState } from "react";
import "./EnhancedDropdown.css";

/*
  This dropdown is built on top of ul/li because of styling limitations of webkit-based browsers
  if you want a regular dropdown, see Dropdown component
  (See https://stackoverflow.com/questions/7208786/how-to-style-the-option-of-an-html-select-element for more details)
 */

const EnhancedDropdown = ({
  items,
  children,
  className = "",
  extendType = "right" /* Possible values:'left', 'center', 'right'.
  Decides if extended dropdown should overflow left or right.
  'center' means overflow will be centered and hidden with ellipsis */,
  value,
  setValue,
  disabled
}) => {
  const [isShowing, setShowing] = useState(false);
  const toggleShow = () => setShowing(!isShowing);
  const extendTypeStyle = () => {
    switch (extendType) {
      case "left":
        return { right: "0" };
      case "center":
        return { width: "100%" };
      default:
        return { left: "0" };
    }
  };
  return (
    <div className={`enhanced-dropdown`}>
      <span className="enhanced-dropdown-triangle"></span>
      <button
        className={`enhanced-dropdown-button ${className}`}
        onClick={toggleShow}
        onBlur={toggleShow}
        disabled={disabled}
      >
        {value
          ? new DOMParser().parseFromString(value, "text/html").documentElement
              .textContent
          : children}
      </button>
      <div
        className={`enhanced-dropdown-items ${isShowing && "show"}`}
        style={extendType ? extendTypeStyle() : {}}
      >
        {items.map(elem => {
          const doc = new DOMParser().parseFromString(elem, "text/html");
          return (
            <span
              className="enhanced-dropdown-item"
              onMouseDown={() => setValue(elem)}
            >
              {doc.documentElement.textContent}
            </span>
          );
        })}
      </div>
    </div>
  );
};

export default EnhancedDropdown;
